export const nextAnimationFrame = () => new Promise(requestAnimationFrame)
